import classNames from 'classnames'

import { initialsFromString } from '@apps-common/helpers/initials-from-string'
import { stringToColor } from '@apps-common/helpers/string-to-color'
import { useTheme } from '@apps-common/hooks/useTheme'

interface IProps {
  classes?: string
  textClasses?: string
  name?: string | null
}

export const ProfileUserInitials: React.FC<IProps> = ({ classes, textClasses, name }) => {
  const { themeMode, isDarkMode } = useTheme()

  const initials = initialsFromString(name)
  const colors = stringToColor(initials, themeMode === 'dark' || isDarkMode)

  return (
    <div
      className={classNames(
        classes,
        colors.bg,
        colors.fg,
        'flex items-center justify-center w-[35px] h-[35px] sm:w-[37px] sm:h-[37px] rounded-full'
      )}
    >
      <span className={classNames(textClasses, 'text-[0.7rem] sm:text-[0.75rem] jost-medium')}>{initials}</span>
    </div>
  )
}
